import { DELETE_TAB_REQUEST, DELETE_TAB_SUCCESS, DELETE_TAB_FAILURE } from '../action/types'

const initialState = {
  data: [],
  error: '',
}

export const deleteLeaderboardtabReducer = (state = initialState, action) => {
  switch (action.type) {
    case DELETE_TAB_REQUEST:
      return {
        ...state,
        loading: true,
      }
    case DELETE_TAB_SUCCESS:
      return {
        ...state,
        loading: false,
      }
    case DELETE_TAB_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      }
    default:
      return state
  }
}
